import { Component, Prop, Vue } from "vue-property-decorator";
import { OrderRow } from "@/models/tapwell/Cart";
import { ApiService } from "@/services/bricmate/ApiService";
import { CheckoutStore } from "@/store/bricmate-b2c/checkoutstate";

@Component
export default class CheckoutCartWarning extends Vue {
    @Prop({ default: () => [] })
    protected rows!: OrderRow[];

    @Prop({ default: false })
    protected catalogMode!: boolean;

    protected isBusy: boolean = false;
    protected error: string = "";
    protected translations: any = window.__litium.translation;

    protected async removeItems() {
        if (this.isBusy) {
            return;
        }
        this.isBusy = true;
        this.error = "";
        try {
            for (const row of this.rows.slice()) {
                const response = await ApiService.updateCart({
                    articleNumber: row.articleNumber,
                    rowSystemId: row.rowSystemId,
                    quantity: 0,
                    comment: "",
                });
                if (!response || !response.data) {
                    throw new Error("Cart update failed");
                }
            }
            await CheckoutStore.reloadState();
            this.$emit("removed");
        } catch {
            this.error = this.translations["checkout.catalogs.error"];
        } finally {
            this.isBusy = false;
        }
    }
}